import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Services", href: "/services/roof-repair" },
  { label: "About", href: "/about" },
  { label: "Colorado Springs", href: "/locations/colorado-springs" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#111111] border-b border-white/10"
          : "bg-gradient-to-b from-black/70 to-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-18 lg:h-22" style={{ height: "72px" }}>
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://storage.readdy-site.link/project_files/f69dad05-caa6-4357-8060-5609c0454105/d6d7c484-28dd-4c76-8a75-b036f9196f61_ThomasLogo.svg?v=69187a6daa2100658c68583a79aaf4a8"
              alt="Thomas Roofing & Repair"
              className="h-16 w-auto object-contain"
              style={{ filter: "brightness(0) invert(1)" }}
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`font-body font-500 text-sm tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === link.href
                    ? "text-[#10B981]"
                    : "text-white/85 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="tel:407-408-0577"
              className="flex items-center gap-2 cursor-pointer whitespace-nowrap transition-colors group"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#10B981]/20 group-hover:bg-[#10B981]/30 transition-colors">
                <i className="ri-phone-fill text-[#10B981] text-sm"></i>
              </div>
              <div className="flex flex-col">
                <span className="text-white/50 font-body text-[10px] leading-none tracking-wider uppercase">Call Now</span>
                <span className="text-white font-body font-700 text-sm leading-tight">(407) 408-0577</span>
              </div>
            </a>
            <Link
              to="/#contact"
              className="bg-[#10B981] hover:bg-emerald-500 text-white text-sm font-body font-700 px-6 py-2.5 rounded-md cursor-pointer whitespace-nowrap transition-all shadow-lg shadow-emerald-900/30"
            >
              Free Inspection
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="lg:hidden bg-[#111111] border-t border-white/10 py-4">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-white/80 hover:text-white font-body font-500 text-sm px-4 py-3 cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
              <div className="px-4 pt-3 pb-1 flex flex-col gap-2">
                <a
                  href="tel:407-408-0577"
                  className="flex items-center gap-2 text-white font-body font-600 text-sm"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-fill text-[#10B981]"></i>
                  </div>
                  (407) 408-0577
                </a>
                <Link
                  to="/#contact"
                  className="bg-[#10B981] hover:bg-emerald-500 text-white text-sm font-body font-700 px-5 py-2.5 rounded-md text-center cursor-pointer whitespace-nowrap transition-colors"
                >
                  Free Inspection
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
